import type { DeviceSettings } from "@tandemdiabetes/sugarmate-api-react-client"
import { useSaveDeviceSettings } from "@tandemdiabetes/sugarmate-api-react-client"
import { useMemo } from "react"
import { excludedInsightKeys } from "./defaultDeviceSettings"
import { useDeviceSettingsList } from "./useDeviceSettingsList"
import type { PartialWithId } from "src/types"
import { noticeError } from "src/utils"

export function useUpdateDeviceSettings() {
  const saveDeviceSettings = useSaveDeviceSettings()
  const {
    mutate,
    data: deviceSettingsList,
  } = useDeviceSettingsList()

  return useMemo(
    () => saveDeviceSettings && (async (deviceSettings: PartialWithId<DeviceSettings>) => {
      try {
        const updatedDeviceSettings = deviceSettings.insights === undefined
          ? deviceSettings
          : {
            ...deviceSettings,
            insights: deviceSettings.insights.filter(
              (insight) => !excludedInsightKeys.has(insight.key),
            ),
          }

        const response = await saveDeviceSettings(updatedDeviceSettings)

        if (deviceSettingsList) {
          const responseDeviceSettings = response.data.device_setting

          const updatedList = deviceSettingsList.map((cachedDeviceSettings) => {
            if (cachedDeviceSettings.id === responseDeviceSettings.id) {
              return responseDeviceSettings
            }

            return cachedDeviceSettings
          })

          void mutate(updatedList)
        } else {
          void mutate()
        }

        return response
      } catch (e) {
        noticeError(
          e,
          "UpdateDeviceSettings",
          { deviceSettings },
        )

        throw e
      }
    }),
    [
      saveDeviceSettings,
      deviceSettingsList,
      mutate,
    ],
  )
}
